<template>
  <component :is="wrapper ?? 'div'">
    <slot v-for="(item, index) in visibleItems" v-bind="{ item, index }" />
  </component>
</template>

<script lang="ts" setup generic="T">
import type { Component, VNode } from "vue";

const props = withDefaults(
  defineProps<{
    items?: Array<T>;
    visibleCount?: number;
    wrapper?: string | Component;
  }>(),
  {
    items() {
      return [];
    },
    visibleCount: 5,
    wrapper: undefined,
  },
);

defineSlots<{
  default(_props: { item: T; index: number }): VNode[];
}>();

const mounted = ref(false);
const visibleItems = computed<T[]>(() =>
  !mounted.value
    ? props.items.slice(0, props.visibleCount) || []
    : props.items || [],
);

onMounted(() => nextTick(() => (mounted.value = true)));
</script>
